import React, { useState } from "react";
import {
  Alignment,
  Button,
  Classes,
  Navbar,
  NavbarDivider,
  NavbarGroup,
  NavbarHeading,
  Icon,
  Menu,
  MenuDivider,
  MenuItem,
  Popover,
  Position
} from "@blueprintjs/core";
import { connect } from "react-redux";
import AboutDialog from "../components/AboutDialog";
import { SAMPLE_TREE, LAYOUTS } from "../constants";
import { setEditorValue, setLayoutType } from "../store/actions";
import { getLayoutType } from "../store/reducers";

import { trackEvent } from "../utils/track";

const FORCES = [
  {
    layoutType: LAYOUTS.default,
    label: "Hello Force",
    icon: "hand"
  },
  {
    layoutType: LAYOUTS.traditional,
    label: "Block Force",
    icon: ""
  },
  {
    layoutType: LAYOUTS.horizontalTree,
    label: "Horizontal Tree",
    icon: ""
  },
  {
    layoutType: LAYOUTS.cola,
    label: "Cola Force",
    icon: ""
  }
];

let ForceMenu = props => {
  return (
    <Menu className={Classes.ELEVATION_1}>
      {FORCES.map((force, i) => (
        <MenuItem
          key={i}
          icon={props.layoutType === force.layoutType ? "selection" : 'circle'}
          text={force.label}
          onClick={() => props.setLayoutType(force.layoutType)}
        />
      ))}
      {/* <MenuDivider />
      <MenuItem
        icon="cog"
        labelElement={<Icon icon="share" />}
        text="Settings..."
      /> */}
    </Menu>
  );
};
ForceMenu = connect(
  state => ({
    layoutType: getLayoutType(state)
  }),
  null
)(ForceMenu);

// TODO: - find a better function for this that preserves fonts etc
function saveSvg(name) {
  const svgEl = document.querySelector('.treeContainer');
  svgEl.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  var svgData = svgEl.outerHTML;
  var preface = '<?xml version="1.0" standalone="no"?>\r\n';
  var svgBlob = new Blob([preface, svgData], {
    type: "image/svg+xml;charset=utf-8"
  });
  var svgUrl = URL.createObjectURL(svgBlob);
  var downloadLink = document.createElement("a");
  downloadLink.href = svgUrl;
  downloadLink.download = name;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
}

const Navigation = props => {
  const [isAboutDialogOpen, setAboutDialogOpen] = useState(false);
  const openDialog = () => {
    trackEvent({
      category: "User",
      action: "Opened About Page"
    });
    setAboutDialogOpen(true);
  };
  const closeDialog = () => setAboutDialogOpen(false);
  const loadSample = () => {
    trackEvent({
      category: "User",
      action: "Load Sample 1"
    });
    props.setEditorValue(SAMPLE_TREE);
  };
  const clear = () => props.setEditorValue("");

  return (
    <Navbar className="bp3-dark">
      <NavbarGroup align={Alignment.LEFT}>
        <NavbarHeading>DUQE</NavbarHeading>
        <NavbarDivider />
        <Button
          className={Classes.MINIMAL}
          icon="info-sign"
          text="About"
          onClick={openDialog}
        />
        <Popover
          content={<ForceMenu setLayoutType={props.setLayoutType} />}
          position={Position.RIGHT_BOTTOM}
        >
          <Button text="Select Layout" />
        </Popover>
      </NavbarGroup>
      <NavbarGroup align={Alignment.RIGHT}>
        <Button
          className={Classes.MINIMAL}
          icon="refresh"
          text="Load Sample"
          onClick={loadSample}
        />
        <Button
          className={Classes.MINIMAL}
          icon="delete"
          text="Clear"
          onClick={clear}
        />
      </NavbarGroup>
      <AboutDialog handleClose={closeDialog} isOpen={isAboutDialogOpen} />
    </Navbar>
  );
};

// const mapStateToProps = state => ({
//   isUseForceLayout: getIsUseForceLayout(state)
// });

export default connect(
  null,
  {
    setEditorValue,
    setLayoutType
  }
)(Navigation);
